
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { hinhThucThanhToanApi } from '../../../api/category/hinhThucThanhToanApi';
import { IHinhThucThanhToan } from '../../../model/respone/category/IHinhThucThanhToan';
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { eHinhThucThanhToanActionTypeIds, IHinhThucThanhToanActions } from '../../action-types/category/IHinhThucThanhToanActionType';
import { rootActions } from '../../actions/rootActions';
const mainAction = rootActions.category.hinhThucThanhToan;
export function* hinhThucThanhToanSaga(): any {
    yield takeLatest(eHinhThucThanhToanActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eHinhThucThanhToanActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eHinhThucThanhToanActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IHinhThucThanhToanActions): any {
    const res: IBaseRespone = yield call(hinhThucThanhToanApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: IHinhThucThanhToanActions): any {
    let res: IBaseRespone;
    const HinhThucThanhToan = action.payload as IHinhThucThanhToan;
    if (HinhThucThanhToan.id > 0) {
        res = yield call(hinhThucThanhToanApi.Update, HinhThucThanhToan)
    } else {
        res = yield call(hinhThucThanhToanApi.Insert, HinhThucThanhToan)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: IHinhThucThanhToanActions): any {
    const res: IBaseRespone = yield call(hinhThucThanhToanApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}